import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import Upload from "../../types/files/Upload";

// Define the type for our state store entry
type UploadsState = {
    uploads: Upload[]
};

// Define the initial state for our state store entry
const initialState: UploadsState = {
    uploads: []
};

// Create a slice to hold all our reducers
const uploadsSlice = createSlice({
    name: "uploads",
    initialState: initialState,
    reducers: {
        addUpload: (state, action: PayloadAction<Upload>) => {
            state.uploads.push(action.payload);
        },
        updateUpload: (state, action: PayloadAction<Upload>) => {
            let item = state.uploads.find(item => item.id.toString() === action.payload.id.toString());

            if (item) {
                item.progress = action.payload.progress;
                item.completed = action.payload.completed;
            }
        },
        removeUpload: (state, action: PayloadAction<Upload>) => {
            let index = state.uploads.indexOf(state.uploads.find(item => item.id.toString() === action.payload.id.toString()));

            if (index >= 0)
                state.uploads.splice(index, 1);
        }
    },
    extraReducers(builder) {
        builder
            .addCase(REHYDRATE, (_, rawData: any) => {
                if (rawData?.key !== "tts") return undefined;

                return {
                    uploads: []
                }
            })
    }
});

export const {
    addUpload,
    updateUpload,
    removeUpload
} = uploadsSlice.actions;

// We have to export the reducer as this is added to the state store
export default uploadsSlice.reducer;